/* eslint-disable react/prop-types */
import { Box } from "@rebass/grid";
import React from "react";
import PropTypes from "prop-types";
import { or } from "airbnb-prop-types";
import styled, { css } from "styled-components/macro";
import { switchProp } from "styled-tools";
import { color, fontSize } from "styled-system";

const Notification = styled(Box)`
  ${fontSize};
  ${color};

  margin: 0;
  display: flex;
  align-items: flex-start;
  width: 100%;

  ${switchProp("variant", {
    major: css`
      color: ${p => p.theme.colors.white};
      background-color: ${p => p.theme.colors.urgentRed};

      button {
        color: ${p => p.theme.colors.white};
        font-size: 14px;
      }

      svg {
        fill: ${p => p.theme.colors.white};
      }
    `,
    warning: css`
      color: ${p => p.theme.colors.dark};
      background-color: ${p => p.theme.colors.goldenYellow};

      button {
        color: ${p => p.theme.colors.dark};
        font-size: 14px;
      }

      svg {
        fill: ${p => p.theme.colors.dark};
      }
    `,
    info: css`
      color: ${p => p.theme.colors.white};
      background-color: ${p => p.theme.colors.dark};

      button {
        color: ${p => p.theme.colors.white};
        font-size: 14px;
      }

      svg {
        fill: ${p => p.theme.colors.white};
      }
    `,
  })}
`;

const OutageStatusNotification = ({ variant, notification }) => (
  <Notification fontSize="16px" py={[10, 10, 10]} px={20} variant={variant}>
    <Box width="100%">
      {typeof notification === "string" && <span>{notification}</span>}

      {typeof notification === "function" && notification()}
    </Box>
  </Notification>
);

OutageStatusNotification.propTypes = {
  variant: PropTypes.oneOf(["info", "warning", "major"]),
  notification: or([PropTypes.string, PropTypes.func]).isRequired,
};

OutageStatusNotification.defaultProps = {
  variant: "info",
};

export default OutageStatusNotification;
